export default "__VITE_ASSET__N0Z4TlOR__"